'use client'

import { ErrorPdp } from '@/components/ErrorPdp'
import { ItemTemplate } from '@/shared/container'
const NotFound = () => {
  return (
    <ItemTemplate>
      <ErrorPdp />
    </ItemTemplate>
  )
}

export default NotFound
